<!--售后详情-->
<template>
    <div>
        <van-cell-group>
            <van-field
                    label="类型"
                    placeholder="请选择售后类型"
                    :value="formData.title"
                    :error = "formValidate&&!formData.title"
                    readonly
                    @click="showTypeSelect"
                    input-align="right"
            />

            <van-field
                    label="问题描述"
                    placeholder="请输入详细的问题描述"
                    input-align="right"
                    :value="formData.note"
                    :error = "formValidate&&!formData.note"
                    v-model="descr"
                    @input="writeDescr"
            />
        </van-cell-group>

<!--        <PicUploader :fileList="fileList" :limit="9" @uploadSuccess="uploadSuccess"></PicUploader>-->
        <PicUploader :fileList="formData.pics" :limit="9" @imageListChange="imageListChange"
                     :name="'pics'"></PicUploader>

        <div class="btn">
            <van-button type="danger" size="large" round @click="formSave" v-if="!loading">确定</van-button>
            <van-button type="danger" size="large" round v-else>确定中...</van-button>
        </div>

        <van-popup
                v-model="selectShow"
                position="bottom"
        >
            <van-picker
                    show-toolbar
                    title="标题"
                    :columns="columns"
                    @cancel="onCancel"
                    @confirm="onConfirm"
            />
        </van-popup>

    </div>
</template>
<style scoped>
    .van-field__body input {
        text-align: right;
    }

    .btn {
        padding: 0 15px;
    }

</style>

<script>
    import { Button ,Field,Popup,Picker,Toast  } from 'vant';
    import PicUploader from '@/components/picker/PicUploader.vue';

    export default {
        components: {
            Button ,
            Field,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            Toast,
            PicUploader
        },
        data: function () {
            return {
                selectShow:false,
                formValidate: false,
                loading: false,
                descr: '',
                columns: ['申请退款', '申请退货', '申请退货并且退款', '申请换货', '其他'],
                formData:{
                    order_id:0,
                    title:'',
                    type:'',
                    note:'',
                    pics:[]
                },
                fileList: []
            }
        },
        filter: {},
        mounted() {
            document.title='售后申请';
            this.getOrderId()
        },
        destroyed() {

        },
        methods: {
            getOrderId() {
                let that = this;
                that.formData.order_id = that.$route.query.order_id;
                // console.log(that.id)
            },

            uploadSuccess(data) {
                let that = this;
                that.formData.pics = [];
                data.map(pic=> {
                    that.formData.pics.push(pic.url)
                })

                // console.log(that.formData.pics);
            },

            imageListChange(data) {
                console.log('data', data)
                let that = this;
                let name = data.name
                that.formData[name] = data.pic
            },

            showTypeSelect() {
                this.selectShow = true;
            },

            writeDescr() {
                let that = this;
                that.formData.note = that.descr;
                // console.log(that.descr)
            },

            onCancel() {
                this.selectShow = false;
            },

            onConfirm(value, index) {
                let that = this;
                that.formData.type = index + 1;
                that.formData.title = value;
                that.selectShow = false;


                console.log(that.formData)
            },
            formSave() {
                let that = this;
                that.formValidate = true;
                that.loading =true;

                this.$api.post('/api/order/refundApplyAdd', that.formData, (res) => {
                    // console.log(res)
                    that.loading = false;
                    this.$router.replace({
                        path: '/orderdetail',
                        query: {
                            id: that.formData.order_id,
                        }
                    })

                },(res) => {
                    Toast(res.msg)
                    that.loading = false;
                })
            }

        }
    }
</script>



// WEBPACK FOOTER //
// ServiceApply.vue?1df87037